<template>
  <div class="cool-login_container"
    v-fixed
    v-if="show"
    @click.self="maskHandle">
      <div class="login-form_wrap">
        <span class="igetcool cool-m-clear close-btn_tag"
          @click="closeHandle"></span>
        <h3 class="login_title"
          v-if="title">{{title}}</h3>
        <h4 class="login_sub-title"
          v-if="realSubTitle"
          :style="subTitleStyles"><img class="title-tips_icon"
            v-if="subTitleIcon"
            :src="subTitleIcon"/><span>{{realSubTitle}}</span></h4>
        <div class="ipt-item_wrap first-ipt-item">
          <div class="contry-code_wrap ipt-desc_title" @click="() => this.select.show = true">
            <span>+{{select.value}}</span>
            <span class="igetcool cool-m-arrow_down"></span>
          </div>
          <input class="phone-code_ipt ipt-item" type="tel" pattern="[0-9]*" ref="mobile"
            :placeholder="phonePlaceholder"
            v-model="phone"
            :maxlength="maxPhonelength"
            @focus="phoneFocusHandle"
            @blur="inputDown"/>
          <div class="right-btn_wrap">
            <span class="igetcool cool-m-clear clear-tag"
              v-if="this.phone"
              @click="() => this.phone = ''"></span>
          </div>
          <div class="error-tips_wrap"
            v-show="phoneError">{{phoneError}}</div>
        </div>
        <div class="ipt-item_wrap">
          <h4 class="ipt-desc_title">验证码</h4>
          <input class="ipt-item"  type="tel" pattern="[0-9]*" ref="refeInput"
            :maxlength="codeMaxLength"
            :placeholder="codePlaceholder"
            v-model="code"
            @focus="codeFocusHandle"
            @blur="inputDown"/>
          <div class="right-btn_wrap"
            v-if="canSendCode"
            @click="sendCode">
            <span class="toggle-code_wrap send-code">获取验证码</span>
          </div>
          <div class="right-btn_wrap count-down_wrap"
            v-else>
            <span class="toggle-code_wrap send-code">重新发送 </span>
            <span class="toggle-code_wrap send-code">{{nowTime}}s</span>
          </div>
          <div class="error-tips_wrap"
            v-show="codeError"><div class="inner">{{codeError}}</div></div>
        </div>
        <div class="act-btn_wrap">
          <button class="login_btn"
            :class="{disabled: disabledLogin}"
            @click="loginHandle">{{loginTxt}}</button>
        </div>
        <div class="protocol-block_wrap"
          v-if="showProtocol">
          <CoolMProtocal
            v-model="hasRead">
            <slot name="protocal"/>
          </CoolMProtocal>
        </div>
      </div>
    <!--号码选择器 -->
    <cool-country-select
      :select="select"/>
  </div>
</template>

<script>
import { fixed } from '@/utils/directives';
import CoolCountrySelect from '../CountrySelect';
import CoolMProtocal from '../Protocal';
import { validateMobile } from '@/utils/validate.js';
import encryptFactory from '@igc-lib/encrypter';
import {
  getCodeRequest,
  loginRegisterRequest
} from './serve';
import { setUserInfo, RSAEncryptInstance } from './utils';

import qs from 'qs';

const ua = navigator.userAgent;
const isIOS14 = /OS 14_/.test(ua);


export default {
  name: 'H5Login',
  props: {
    title: {
      type: String,
      default: '登录/注册少年得到'
    },
    subTitle: [String, Object],
    subTitleIcon: String,
    phonePlaceholder: {
      type: String,
      default: '请输入手机号'
    },
    channel: String,
    codeMaxLength: {
      type: Number,
      default: 4
    },
    loginTxt: {
      type: String,
      default: '立即登录'
    },
    codePlaceholder: {
      type: String,
      default: '请输入验证码'
    },
    show: Boolean,
    maskEvent: Boolean,
    errorMsgs: Object,
    stringify: Boolean,
    showProtocol: Boolean,
    protocolTip: {
      type: String,
      default: '请先阅读并勾选服务协议'
    }
  },
  data() {
    const urlSearch = new URLSearchParams(location.search);
    let defaultChannel = urlSearch.get('igc_from');

    return {
      defaultChannel,
      select: {
        show: false,
        value: 86
      },
      code: '',
      phone: '',
      fullTime: 60,
      nowTime: 60,
      timer: null,
      regLock: false,
      sendCodeLock: false,
      canSendCode: true,
      phoneError: '',
      codeError: '',
      realSubTitle: '',
      subTitleStyles: '',
      hasRead: false // 是否阅读隐私协议
    };
  },
  computed: {
    disabledLogin() {
      return this.validatePhone || this.code.length !== this.codeMaxLength;
    },
    validatePhone() {
      return this.phone.length < (this.select.value == '86' ? 11 : 1);
    },
    maxPhonelength() {
      return this.select.value !== 86 ? 1000 : 11;
    }
  },
  watch: {
    subTitle(subOpt) {
      if (subOpt) {
        if (typeof subOpt === 'object') {
          const { styles = {}, title = '' } = subOpt;
          this.realSubTitle = title;
          this.subTitleStyles = styles;
        } else {
          this.realSubTitle = subOpt;
        }
      }
    }
  },
  directives: {
    fixed
  },
  methods: {
    phoneFocusHandle(evt) {
      this.phoneError = '';
      clearTimeout(this.loginTimer);
      if (isIOS14) {
        window.scrollTo(0, 100000);
      }
    },
    codeFocusHandle(evt) {
      this.codeError = '';
      clearTimeout(this.loginTimer);
      if (isIOS14) {
        window.scrollTo(0, 100000);
      }
    },
    maskHandle() {
      this.maskEvent && this.closeHandle();
    },
    closeHandle() {
      if (this.regLock) { return false }
      this.$emit('cancel');
    },
    sendCode() {
      if (this.validatePhone) {
        this.phoneError = '手机号格式错误';
        return;
      }
      if (this.sendCodeLock) { return }
      let phoneStatus = validateMobile(this.phone, this.select.value);
      if (!phoneStatus) {
        this.$coolToast({
          text: '手机号码格式不正确',
          time: 3000
        });
        this._lockRequestCode();
        return;
      }
      this.sendCodeRequest();
    },
    _handleSendCode(res) {
      const errorMsgObj = {
        400011: '手机号已注册',
        ...this.errorMsgs
      };
      const error = errorMsgObj[res.code] || res.msg || '网络错误';
      if (res.code !== 10000) {
        this.$coolToast({
          text: error,
          time: 3000
        });
      }
    },
    _handleTimer() {
      clearTimeout(this.timer);
      this.nowTime = 60;
      this.timer = setInterval(() => {
        this.nowTime = this.nowTime - 1;
        if (this.nowTime === 0) {
          this.canSendCode = true;
          this.nowTime = this.fullTime;
          clearTimeout(this.timer);
        }
      }, 1000);
    },
    loginHandle() {
      const aboutProtocal = this.showProtocol && !this.hasRead;
      if (aboutProtocal) {
        this.$coolToast(this.protocolTip);
      }
      this.codeFocusHandle();
      if (this.regLock || this.disabledLogin || aboutProtocal) { return }
      let defaultParams = this._getParams();
      let headers = {};
      if (this.defaultChannel) {
        headers['App-Channel'] = encodeURIComponent(this.defaultChannel);
      }
      if (this.channel) {
        headers['App-Channel'] = encodeURIComponent(this.channel);
      }
      let requestOptions = {
        params: defaultParams,
        headers
      };
      if (typeof this.beforeLogin === 'function') {
        let result = this.beforeLogin({ ...defaultParams });
        result && (requestOptions = result);
        this.beforeLogin = null;

      }
      if (this.isDecryptAES) {
        requestOptions.axiosOption = {
          transformResponse: [async function(data, header) {
            try {
              data = JSON.parse(data);
            } catch (error) {
              data = data;
            }
            let tempAtime = header['app-atime'].substring(5, 13);
            let tempNonce = header['app-nonce'].substring(5, 13);
            let secret = tempAtime + tempNonce;

            data.data = encryptFactory('AES', {
              publicKey: secret
            }).decrypt(data.data);
            return data;
          }],
        };
      }
      this._registerAjax(requestOptions);
    },
    // 注册请求
    async _registerAjax(requestOptions) {
      try {
        let { params, api, headers, axiosOption } = requestOptions;
        if (this.stringify) {
          params = qs.stringify(params);
        }
        this._lockRequestCode(true);
        const res = await loginRegisterRequest(params, api, headers, axiosOption);
        if (res.code === 10000) {
          const { token, userId: uid } = res.data;
          setUserInfo({
            token,
            uid,
            phone: this.phone
          });
          this.loginSuccess(res.data);
          this.resetData();
        } else {
          this.codeError = res.msg;
          // this.$emit('error', res);
        }
      } catch (error) {
        this.$emit('error', error);
      }
      finally {
        this._unLockRequestCode(true);
      }
    },
    loginSuccess(data) {
      this.$emit('login', data);
    },
    _getParams() {
      this.$refs.refeInput.blur();
      let params = {
        phone: RSAEncryptInstance(this.phone),
        decryptPhone: this.phone,
        countryCode: this.select.value || 86,
        encryptCountryCode: RSAEncryptInstance(String(this.select.value) || '86'),
        smsCode: RSAEncryptInstance(this.code)
      };
      return params;
    },
    inputDown() {
      this.loginTimer = setTimeout(() => {
        // window.scrollTo(0, 0);
        document.activeElement.scrollIntoViewIfNeeded(true);
      }, 300);
    },
    async sendCodeRequest() {
      this._lockRequestCode();
      const query = {
        phone: RSAEncryptInstance(this.phone),
        countrycode: RSAEncryptInstance(this.select.value + '')
      };
      try {
        const res = await getCodeRequest(query);
        if (res.code === 10000) {
          this.canSendCode = false;
          this._handleTimer();
        }
        this._handleSendCode(res);
      } catch (error) {
        this.$emit('error', error);
      }
      finally {
        this._unLockRequestCode();
      }
    },
    resetData(all) {
      this.phone = '';
      this.code = '';
      this.phoneError = '';
      this.codeError = '';
      this.canSendCode = true;
      this.nowTime = 60;
      clearTimeout(this.timer);
    },
    _lockRequestCode(reg) {
      if (reg) {
        this.regLock = true;
        return;
      }
      this.sendCodeLock = true;
    },
    _unLockRequestCode(reg) {
      if (reg) {
        this.regLock = false;
        return;
      }
      this.sendCodeLock = false;
    }
  },
  created() {

  },
  components: {
    CoolCountrySelect,
    CoolMProtocal
  }
};
</script>

<style lang="stylus">
.cool-login_container
  position fixed
  top 0
  bottom 0
  left 0
  width 100%
  background-color rgba(0, 0, 0, .6)
  z-index 10000
  .login-form_wrap
    box-sizing border-box
    position absolute
    bottom 0
    left 0
    right 0
    padding .4rem .4rem .3rem
    font-size 0.16rem
    min-height 3.2rem
    background-color #ffffff
    border-top-left-radius .2rem
    border-top-right-radius .2rem
    .cool-m-clear:before {
      content: "\e606";
    }
  .close-btn_tag
    position absolute
    top .2rem
    right .08rem
    font-size .38rem
    color rgba(0, 0, 0, .3)
  .login_title
    font-weight 500
    font-size .24rem
    letter-spacing 0
    line-height .3rem
    color #41414D
    text-align center
    margin-bottom .1rem
    font-weight normal
  .login_sub-title
    display flex
    justify-content center
    align-items center
    line-height .2rem
    font-size .14rem
    font-weight normal
    color #FF5E2E
    .title-tips_icon
      width .18rem
      height .18rem
      vertical-align middle
      margin-right .02rem
  .ipt-item_wrap
    position relative
    height .44rem
    display flex
    align-items center
    border-bottom solid .01rem #E6E6EB
    margin-bottom .2rem
    &.first-ipt-item
      margin-top .3rem
    .error-tips_wrap
      position absolute
      bottom -.22rem
      line-height .18rem
      color red
      font-size .12rem
      padding-left .65rem
      white-space nowrap
  .ipt-item
    font-size .16rem
    height 100%
    flex 1
  .ipt-desc_title
    width .65rem
    font-size .16rem
    color #41414D
    font-weight 400
  .right-btn_wrap
    position absolute
    right 0
    top 0
    bottom 0
    display flex
    justify-content flex-end
    align-items center
    background-color #ffffff
    &.count-down_wrap
      width .84rem
      justify-content space-between
      .send-code
        color #c6c7cb
    .clear-tag
      font-size .24rem
  .toggle-code_wrap
    line-height .18rem
    font-size .14rem
    &.send-code
      color #FF5F2E
  .act-btn_wrap
    text-align center
    margin-top .3rem
  .login_btn
    width 100%
    height .5rem
    border-radius .25rem
    font-size .18rem
    font-weight 700
    color #ffffff
    background-image linear-gradient(to left, #FF854B, #FF5F2E)
    &.disabled
      opacity .2
  input, button
    outline none
    border none

  .protocol-block_wrap
   margin-top .2rem

  .slide-fade-enter-active
    transition all 0.3s ease


  .slide-fade-leave-active
    transition all 0.3s cubic-bezier(1, 0.5, 0.8, 1)


  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */

    transform translateY(100px)
    opacity 0


  @keyframes fade
    from
      opacity 1

    50%
      opacity 0.4

    to
      opacity 1



  @-webkit-keyframes fade
    from
      opacity 1

    50%
      opacity 0.4

    to
      opacity 1
</style>
